import React, { useState } from 'react';

import Helpers from '../../helpers';

function FileURLInput(props) {

  const [url, setURL] = useState(getURL(props.node));

  function getURL(node) {

    let url = '';

    if (node.attributes.file !== null) {
      url = node.attributes.file.url;
    }

    return url;

  }

  function updateEditor(url) {

    const attributes = { ...props.node.attributes };

    let file = {
      ...(attributes.file || {})
    };

    file.url = url;

    attributes.file = file;

    Helpers.setAttributes(props.editor, { attributes }, props.elementPath);

  }

  function handleFileURLInputChange(event) {

    const _value = event.target.value;

    setURL(_value);

    const value = _value.trim();

    if (value === '') {
      return;
    }

    updateEditor(value);

  }

  function renderMain() {

    const inputAttributes = {
      type: 'text',
      placeholder: 'https://...',
      value: url,
      onChange: handleFileURLInputChange
    };

    return <div className="file-url-input-main">

      <input {...inputAttributes} />

    </div>;
  }

  return renderMain();
}

export default FileURLInput;